import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

import { categories } from '@config/categories'

export const getCategoryPathForId = (categoryId: CreditCardProductCategory) => {
    return categories[categoryId]?.path
}
